import { render } from "./investment.vue?vue&type=template&id=5745f391&scoped=true"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"

import "./investment.vue?vue&type=style&index=0&id=5745f391&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5745f391"]])

export default __exports__